'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.Flex = Flex;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _box = require('./box');

var _box2 = _interopRequireDefault(_box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Helper component for Flex elements
 *
 * @example
 * <Flex flexDirection='column'>
 *      content
 * </Flex>
 */
function Flex(props) {
  return _react2['default'].createElement(_box2['default'], _extends({}, props, { display: 'flex' }));
}

exports['default'] = Flex;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/blocks/flex.jsx
 ** module id = 417
 ** module chunks = 0 1
 **/